import React, {Component} from 'react';
import "./complex-meta-data-table.css";

class ComplexMetaDataTable extends Component {
    componentDidMount() {
    }

    formatValue(value) {
        if (value === "#X") {
            value = <i class='fa fa-times class complex_meta_fail'></i>;
        }
        else if (value === "#V") {
            value = <i class='fa fa-check class complex_meta_success'></i>;
        }

        return value;
    }

    prepareData(data) {
        if (!data) {
            return [];
        }
        let content = [];
        let headContent = [];
        let bodyContent = [];
        let tableHeaders = [];
        let firstData = data[0];        
        for (let key in firstData) {                            
            tableHeaders.push(key)
            headContent.push(<th className='complex_meta_data'>{key}</th>);
        }  

        let currentData;
        
        for (let index in data) {
            let rowContent = [];
            currentData = data[index];
            for (let headerIndex in tableHeaders) {
                let key = tableHeaders[headerIndex];
                
                if (!(typeof currentData[key] === "undefined")) {
                    let value = this.formatValue(currentData[key]);

                    rowContent.push(<td className='complex_meta_data'>{value}</td>)
                }
                else {
                    rowContent.push(<td className='complex_meta_data'></td>);
                }
            }

            bodyContent.push(<tr>{rowContent}</tr>);
        }

        content.push(<table className='complex_meta_table'>
                        <thead>
                            <tr>{headContent}</tr>
                        </thead>
                        <tbody>
                            {bodyContent}
                        </tbody>                        
                    </table>
                    )

        return content;
    }
    render() {
        const {data} = this.props;
    
        return (this.prepareData(data));
    }
}

export default ComplexMetaDataTable;


// WEBPACK FOOTER //
// ./src/components/components/results/complex-meta-data-table.js